import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { CommonMap } from 'client/tracking/maps/common';

const map = {
  add_vehicle_compare: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.ADD_VEHICLE_COMPARE
  ),
  compare_suggested_set: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.SUGGESTED_COMPARE_SET
  ),
  view_ev_tax_credit: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_VIEW_CONTENT,
    TrackingConstant.VIEW_EV_TAX_CREDIT
  ),
  srp_link: TrackingEvent.actionCompleted(TrackingConstant.VIEW_SEARCH_RESULT, 'srp_link'),
  comparator_core_link: TrackingEvent.actionCompleted(TrackingConstant.ACTION_MMY_SELECT, 'comparator_core_link'),
  comparator_view_other_styles: TrackingEvent.actionCompleted(
    TrackingConstant.AVAILABLE_ON_OTHER_STYLES,
    'view_other_styles'
  ),
  comparator_select_other_style: TrackingEvent.actionCompleted(
    TrackingConstant.AVAILABLE_ON_OTHER_STYLES,
    'select_other_style'
  ),
  comparator_change_style: TrackingEvent.actionCompleted(TrackingConstant.AVAILABLE_ON_OTHER_STYLES, 'change_style'),
  view_trim_features: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, 'view_trim_features'),
  drivetrain_select: TrackingEvent.actionCompleted(TrackingConstant.ACTION_MMY_SELECT, 'drivetrain_select'),
  trim_cards_srp_button: TrackingEvent.actionCompleted(TrackingConstant.VIEW_SEARCH_RESULT, 'trim_cards_srp_button'),
  trim_select: TrackingEvent.actionCompleted(TrackingConstant.ACTION_MMY_SELECT, TrackingConstant.TRIM_SELECT),
  remove_trim: TrackingEvent.actionCompleted(TrackingConstant.ACTION_VIEW_CONTENT, 'remove_trim'),
};

export const ComparatorMap = {
  ...CommonMap,
  ...map,
};
